import { z } from 'zod'
import { plannerSearchSchema } from '@/features/wedding-plan/components/planner-tabs'

/** `?moment=<id>` alone opens Momenty dne at that moment, so other sections can link to it. */
export const photoSearchSchema = plannerSearchSchema
  .extend({
    panel: z.enum(['overview', 'moments', 'shot-list']).optional().catch(undefined),
    moment: z.string().optional().catch(undefined),
    /** The shot-list group open for editing. */
    group: z.string().optional().catch(undefined),
  })
  .transform((search) =>
    search.moment && !search.panel ? { ...search, panel: 'moments' as const } : search,
  )

/** Opens one moment on Momenty dne, or the list without `moment`. */
export const momentSearch = (moment: string | undefined) => ({ panel: 'moments' as const, moment })
